import { useFragment, useQuery } from "@apollo/client";
import { StyleProp, ViewStyle } from "react-native";
import GetUserForProfilePictureDocument from "src/api/graphql/__generated__/documents/GetUserForProfilePictureDocument";
import UserProfilePictureFragmentFragmentDoc from "src/api/graphql/__generated__/documents/UserProfilePictureFragmentFragmentDoc";
import ProfilePictureContent from "src/components/ProfilePicture/components/ProfilePictureContent";
import { ProfilePictureUser } from "../types";

const ProfilePictureRowUser = ({
	user,
	size,
	style,
}: {
	user: ProfilePictureUser;
	size: number;
	style?: StyleProp<ViewStyle>;
}) => {
	const userId = typeof user === "string" ? user : user?.userId;
	const { data: cacheData } = useFragment({
		fragment: UserProfilePictureFragmentFragmentDoc,
		from: {
			__typename: "User",
			userId,
		},
	});
	const { data } = useQuery(GetUserForProfilePictureDocument, {
		variables: {
			input: {
				userId,
			},
		},
		skip: typeof user !== "string",
		fetchPolicy: "cache-and-network",
	});
	const profilePictureUrl =
		(typeof user !== "string" ? user?.profilePicture?.url : null) ??
		data?.getUser?.profilePicture?.url ??
		cacheData?.profilePicture?.url;

	return (
		<ProfilePictureContent
			size={size}
			user={{
				userId,
				profilePicture: {
					url: profilePictureUrl,
				},
			}}
			style={style}
		/>
	);
};
export default ProfilePictureRowUser;
